import { createAppDispatchHook } from '@kanda-libs/ks-frontend-services';
import { AppDispatch, RootState } from 'store';

export function useAppDispatch() {
  const hook = createAppDispatchHook<RootState, AppDispatch>();
  return hook();
}
